import type React from 'react';

const Logo: React.FC = () => {
  return (
    <img
      alt="logo"
      className="absolute top-4 left-4 z-[10] m-[4] max-w-[95px]"
      height={40}
      id="logo"
      src="/assets/opentable/images/logo.png"
      style={{ margin: '16px' }}
      width={95}
    />
  );
};

export default Logo;
